import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.css";  // Global styles (optional)

const root = ReactDOM.createRoot(document.getElementById("root"));

// test
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
